import { ComponentType, FC, useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';
import { RandomString } from '@csp/csp-common-util';
import { toErrorInfo } from '@csp/csp-common-model';
import { ErrorService } from '../../service/ErrorService';
import { ErrorComponentProps } from './ErrorBoundary';

type Props = {
  ErrorComponent: ComponentType<ErrorComponentProps>;
};

export const ReactRouterErrorElement: FC<Props> = ({ ErrorComponent }) => {
  const error = useRouteError();
  const [errorId, setErrorId] = useState<string>();

  useEffect(() => {
    const errorId = toErrorInfo({ error }).id ?? RandomString.ofLength(8);
    setErrorId(errorId);
    ErrorService.handleError({ error, errorId });
  }, [error]);

  return <ErrorComponent errorId={errorId} />;
};
